import React, { useEffect, useRef, useCallback } from "react";
import { toast, ToastContainer } from "react-toastify";
import Configuration from "../../../configuration";
import Select from "react-select";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { fetchProduit, produitAddedParent, produitGetById } from "../../../Redux/produitReduce";
import { useTranslation } from 'react-multi-lang'
import { useDispatch } from "react-redux";
import { verification } from "../../../Redux/usersReduce";

function AjouterProduitParent({ client }) {

  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  const t = useTranslation();
  var id = 0
  if (isNaN(location.id) === true) document.title = t("Produit.add");
  else {
    id = location.id;
    document.title = t("Produit.update");
  }
  const [codeArticle, setCodeArticle] = React.useState(null);
  const [codePct, setCodePct] = React.useState(null);
  const [designation, setDesignation] = React.useState(null);

  const [optionsProduit, setOptionsProduit] = React.useState([]);
  const [produitSelect, setProduitSelect] = React.useState(null);

  const getProduits = useCallback(
    async (p) => {
      var type = await dispatch(fetchProduit({ client,view:"releve" }));
      var entities = type.payload;
      var arrayOption = [];
      entities.forEach((e) => {
        arrayOption.push({
          value: e.id,
          label: e.Designation_1,
          codeArticle: e.Code_article,
          codePct: e.Code_PCT,
        });
          console.log(p)
        if (e.id === p) {
          setProduitSelect({ value: e.id, label: e.Designation_1 });
        }
      });
      setOptionsProduit(arrayOption);
    },
    [dispatch]
  );


  const saveCalled = useRef(false);

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }



  function submitForm(event) {
    if (!produitSelect) {
      notify(2, t("problem"));
      return;
    }
    if (saveCalled.current) return
    saveCalled.current = true;

    dispatch(
      produitAddedParent({
        id,
        parent: produitSelect.value,designation,codeArticle,codePct
      })
    )
      .then((e) => {
        if (e.payload === true) {
          notify(1, t("add_txt"));
          setTimeout(() => {
            navigate.push(`${client}/produitListFourV`);
          }, 800);
        } else {
          notify(2, t("problem"));
          saveCalled.current = false;
        }
      })
      .catch((error) => {
        notify(2, t("erreur_add"));
        saveCalled.current = false;
        console.error("Error updating produit:", error);
      });
  }


  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
    async function getProduit() {
      if (isNaN(location.id) === false) {
        var produit = await dispatch(produitGetById(location.id));
        var entities = produit.payload;

        if (entities === false) {
          navigate.push(client + '/produitListFourV');
        }
        else {
          setCodeArticle(entities.Code_article);
          setCodePct(entities.Code_PCT);
          setDesignation(entities.Designation_1);
          getProduits(entities.parent)
        }
      } else {
        getProduits()
      }
    }
    getProduit()
  }, [location.id, dispatch, navigate]);

  function listeProduit() {
    navigate.push(client + '/produitListFourV');
  }
  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={listeProduit}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t('list')}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">
                      {typeof location.id == "undefined"
                        ? t('Produit.add')
                        : t('Produit.update')}
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>Code PCT</label>
                          <Form.Control
                            value={codePct}
                            placeholder="Code PCT"
                            type="text"
                            onChange={(value) => {
                              setCodePct(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label>Code Article </label>
                          <Form.Control
                            value={codeArticle}
                            placeholder="Code"
                            type="text"
                            onChange={(value) => {
                              setCodeArticle(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>Designation* </label>
                          <Form.Control
                            value={designation}
                            placeholder="Designation"
                            name="Designation"
                            className="required"
                            type="text"
                            onChange={(value) => {
                              setDesignation(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                        <div className="error"></div>
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group id="roleClass">
                          <label>Produit parent </label>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            value={produitSelect}
                            onChange={(value) => {
                              setProduitSelect(value);
                              setCodeArticle(value.codeArticle);
                              setCodePct(value.codePct);
                            }}
                            options={optionsProduit}
                          />
                        </Form.Group>
                      </Col>

                    </Row>

                    <Button
                      className="btn-fill pull-right"
                      type="button"
                      variant="info"
                      onClick={submitForm}
                    >
                      {t('save')}
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </div>
      </Container >
    </>
  );
}

export default AjouterProduitParent;
